
export const POINTER_SIZE = 14;

export const styles = (theme) => {

  const pointer = POINTER_SIZE * 1.5;
  const qcardPositionBase = {
    content: "' '",
    width: 0,
    height: 0,
    border: `${POINTER_SIZE}px solid transparent`,
    position: 'absolute',
    left: '100%',
    top: '50%',
    marginRight: -POINTER_SIZE,
    marginTop: -POINTER_SIZE,
  };
  return ({
    wrapperOff: {
      position: 'absolute',
    },
    qcardPositionBase,
    qcard: {
      willChange: 'top, left, width, height, opacity',
      transitionProperty: 'top, left, width, height',
      transitionDuration: '.4s',
      transitionTimingFunction: 'ease',
      position: 'fixed',
      top: 0,
      left: 0,
      width: 300,
      height: 100,
      background: theme.palette.cuecards.surface,
      zIndex: 1202,
      borderRadius: 5,
      boxShadow: `${theme.palette.border.shadow} 5px 5px 10px`,
      '&.left': {
        '&:after': {
          ...qcardPositionBase,
          borderLeft: `${POINTER_SIZE}px solid ${theme.palette.cuecards.surface}`,
        },
      },
      '&.right': {
        '&:after': {
          ...qcardPositionBase,
          borderRight: `${POINTER_SIZE}px solid ${theme.palette.cuecards.surface}`,
          right: '100%',
          left: 'unset',
          marginLeft: -POINTER_SIZE,
          marginTop: -POINTER_SIZE,
          marginRight: 'unset',
        },
      },
      '&.righttop': {
        '&:after': {
          ...qcardPositionBase,
          borderRight: `${POINTER_SIZE}px solid ${theme.palette.cuecards.surface}`,
          right: '100%',
          left: 'unset',
          top: pointer,
          marginRight: 'unset',
        },
      },
      '&.rightbottom': {
        '&:after': {
          ...qcardPositionBase,
          borderRight: `${POINTER_SIZE}px solid ${theme.palette.cuecards.surface}`,
          right: '100%',
          left: 'unset',
          top: 'unset',
          bottom: pointer,
          marginRight: 'unset',
        },
      },
      '&.lefttop': {
        '&:after': {
          ...qcardPositionBase,
          borderLeft: `${POINTER_SIZE}px solid ${theme.palette.cuecards.surface}`,
          top: pointer,
        },
      },
      '&.leftbottom': {
        '&:after': {
          ...qcardPositionBase,
          borderLeft: `${POINTER_SIZE}px solid ${theme.palette.cuecards.surface}`,
          top: 'unset',
          bottom: pointer,
        },
      },
    },
    buttonArea: {
      position: 'absolute',
      bottom: 0,
      width: '100%',
      textAlign: 'center',
      padding: 5,
    },
    contentArea: {
      marginTop: 10,
      paddingLeft: 10,
      paddingRight: 10,
    },
    title: {
      color: theme.palette.cuecards.title,
      fontSize: 16,
      paddingRight: 20,
    },
    content: {
      marginTop: 10,
      color: theme.palette.cuecards.text,
      fontSize: theme.typography.fontSize,
    },
    closeBox: {
      position: 'absolute',
      right: 5,
      top: 5,
    },
    closeIcon: {
      color: theme.palette.cuecards.text,
    },
    buttonText: {
      color: theme.palette.cuecards.link,
    },
    highlight: {
      boxShadow: `${theme.palette.overlayScale.black60} 0px 0px 18px`,
    },
  });
};
